import { render } from "./SignatureImage.vue?vue&type=template&id=d2ca9ea0"
import script from "./SignatureImage.vue?vue&type=script&lang=js"
export * from "./SignatureImage.vue?vue&type=script&lang=js"
script.render = render

export default script